module.exports = __webpack_public_path__ + "img/store_icon.0ed9d718.png";